import React from "react";

import classnames from "classnames";
import EmployeeSelect from "./EmployeeSelect";
import store from "./store";
import { updatePayrollEntry } from "./actions";

class PayrollEntry extends React.Component {
  componentDidUpdate(prevProps, _prevState) {
    if (prevProps.entry.total !== this.props.entry.total) {
      const entry = { key: this.props.entry.key };
      entry.total = this.calculateTotalSalary(entry);

      store.dispatch(updatePayrollEntry({ entry }));
    }
  }

  handleChange = (event) => {
    const { name, value } = event.target;

    var entry = { key: this.props.entry.key };
    if (name === "advance") {
      entry[name] = value.replace(/^-/, "");
    } else {
      entry[name] = value;
    }
    entry.total = this.calculateTotalSalary(entry);

    store.dispatch(updatePayrollEntry({ entry }));
  };

  onKeyPress = (event) => {
    const {
      target: { name },
      key,
    } = event;

    let regex = /[0-9.]/g;

    const fieldsAllowNegativeNumber = [
      "discretionary_bonus",
      "refund",
      "advance",
    ];
    if (fieldsAllowNegativeNumber.includes(name)) regex = /[0-9.-]/g;

    if (!regex.test(key)) event.preventDefault();
  };

  calculateTotalSalary(entry) {
    const wage = this.fetch("wage_salary", entry);
    const hours = this.fetch("hours", entry);
    const overtime = this.fetch("overtime", entry);

    const regularPay = hours * wage;
    const overtimePay = overtime * wage * 1.5;

    const sumFields = [
      "month_salary",
      "tip",
      "bonus",
      "comm",
      "refund",
      "reimbursement",
    ];
    let additionalPay = 0;
    sumFields.forEach((field) => (additionalPay += this.fetch(field, entry)));

    const totalSalary =
      regularPay + overtimePay + additionalPay - this.fetch("advance", entry);
    return totalSalary.toFixed(2);
  }

  changeName() {
    return (value) => {
      if (typeof value == "string") {
        var value = { id: null, name: value };
      }

      var entry = {
        key: this.props.entry.key,
        employee_id: value.id,
        name: value.name,
      };

      store.dispatch(updatePayrollEntry({ entry }));
    };
  }

  fetch(name, entry) {
    return this.floatOrZero(entry[name] || this.props.entry[name]);
  }

  floatOrZero(val) {
    return parseFloat(val) || 0;
  }

  formatAdvanceForDisplay(value) {
    if (value === undefined || value === null || value === 0 || value === "0") {
      return "0";
    }
    if (value === "") {
      return "";
    }
    const strValue = value.toString();

    return `-${strValue}`;
  }

  numericOnly(val, field) {
    let regex = /[^\d\.]/g;

    const fieldsAllowNegativeNumber = ["refund", "advance"];
    if (fieldsAllowNegativeNumber.includes(field)) regex = /[^-\d\.]/g;

    return (val || 0).toString().replace(regex, "");
  }

  joinErrors(errors, field) {
    if (!errors[field]) return "";
    return errors[field].map((i) => i.message).join(", ");
  }

  hasError(name) {
    return this.props.errors[name] != null;
  }

  inputField(name, value, klass) {
    klass = klass || name;

    if (!this.props.isEditing)
      return (
        <input
          className={classnames("form-control", klass)}
          disabled={true}
          value={parseFloat(value).toFixed(
            ["wage_salary", "month_salary"].includes(name) ? 5 : 2
          )}
          type="text"
        />
      );

    return (
      <input
        className={classnames("form-control", klass, {
          "is-invalid": this.hasError(name),
        })}
        onChange={this.handleChange}
        value={value}
        name={name}
        onKeyPress={this.onKeyPress}
        type="text"
      />
    );
  }

  inputCheckboxField = (e) => {
    store.dispatch(
      updatePayrollEntry({
        key: this.props.entry.key,
        toDelete: e.target.checked,
      })
    );
  };

  render() {
    return (
      <tr
        className={classnames({
          saved: this.props.entry.id,
          "new-employee": !this.props.entry.id,
        })}
      >
        <td>
          {!this.props.isEditing ? (
            this.props.entry.name
          ) : (
            <EmployeeSelect
              onChange={this.changeName()}
              value={{
                id: this.props.entry.employee_id,
                name: this.props.entry.name,
              }}
            />
          )}

          <div className="invalid-feedback">
            {this.joinErrors(this.props.errors, "name")}
          </div>
        </td>
        <td>
          {this.inputField("hours", this.props.entry.hours)}
          <div className="invalid-feedback">
            {this.joinErrors(this.props.errors, "hours")}
          </div>
        </td>
        <td>
          {this.inputField("overtime", this.props.entry.overtime)}
          <div className="invalid-feedback">
            {this.joinErrors(this.props.errors, "overtime")}
          </div>
        </td>
        <td>
          {this.inputField("wage_salary", this.props.entry.wage_salary, "wage")}
          <div className="invalid-feedback">
            {this.joinErrors(this.props.errors, "wage_salary")}
          </div>
        </td>
        <td>
          {this.inputField(
            "month_salary",
            this.props.entry.month_salary,
            "salary"
          )}
          <div className="invalid-feedback">
            {this.joinErrors(this.props.errors, "month_salary")}
          </div>
        </td>
        <td>
          {this.inputField("tip", this.props.entry.tip)}
          <div className="invalid-feedback">
            {this.joinErrors(this.props.errors, "tip")}
          </div>
        </td>
        <td>
          {this.inputField("bonus", this.props.entry.bonus)}
          <div className="invalid-feedback">
            {this.joinErrors(this.props.errors, "bonus")}
          </div>
        </td>
        <td>
          {this.inputField("comm", this.props.entry.comm)}
          <div className="invalid-feedback">
            {this.joinErrors(this.props.errors, "comm")}
          </div>
        </td>
        <td>
          {this.inputField("refund", this.props.entry.refund)}
          <div className="invalid-feedback">
            {this.joinErrors(this.props.errors, "refund")}
          </div>
        </td>
        <td>
          {this.inputField("reimbursement", this.props.entry.reimbursement)}
          <div className="invalid-feedback">
            {this.joinErrors(this.props.errors, "reimbursement")}
          </div>
        </td>
        <td>
          {this.inputField(
            "advance",
            this.formatAdvanceForDisplay(this.props.entry.advance)
          )}
          <div className="invalid-feedback">
            {this.joinErrors(this.props.errors, "advance")}
          </div>
        </td>
        <td className="total">
          {parseFloat(this.props.entry.total).toFixed(2)}
        </td>
        <td>
          {this.props.isEditing && (
            <input type="checkbox" onChange={this.inputCheckboxField} />
          )}
        </td>
      </tr>
    );
  }
}

// EditPayrollEntry.propTypes = {
//   id: PropTypes.node,
//   hours: PropTypes.number,
//   wage_salary: PropTypes.number,
//   month_salary: PropTypes.number,
//   tip: PropTypes.tip,
//   total: PropTypes.number
// };

export default PayrollEntry;
